var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0918 3.72524C17.591 5.18023 18.5602 6.82527 18.9764 7.61506C18.0574 9.09141 15.0183 13.2134 9.99936 13.2134C4.98046 13.2134 1.94137 9.09141 1.02234 7.61506C1.43852 6.82527 2.40773 5.18024 3.90692 3.72524C5.44977 2.22787 7.47956 1 9.99936 1C12.5192 1 14.549 2.22787 16.0918 3.72524ZM19.9008 7.22478C20.0411 7.4952 20.0301 7.80977 19.871 8.06959C18.9871 9.51268 15.6725 14.2134 9.99936 14.2134C4.32625 14.2134 1.01163 9.51268 0.127728 8.06959C-0.0314148 7.80977 -0.0424226 7.4952 0.0979488 7.22478C0.935048 5.61211 4.26044 0 9.99936 0C15.7383 0 19.0637 5.61211 19.9008 7.22478ZM10.0008 11.5477C12.5394 11.5477 14.5973 9.55907 14.5973 7.106C14.5973 4.65293 12.5394 2.66432 10.0008 2.66432C7.46228 2.66432 5.40436 4.65293 5.40436 7.106C5.40436 9.55907 7.46228 11.5477 10.0008 11.5477Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSolid);
export default __webpack_public_path__ + "static/media/view_solid.d1d5842edd84ad3a163509d3040f4348.svg";
export { ForwardRef as ReactComponent };